export default "/images/13c92744f06881989980bd1a38c83aa7.avif";